import { Component } from '@angular/core';
import { Product } from '@spartacus/core';
import { CurrentProductService, ProductImagesComponent } from '@spartacus/storefront';
import { BehaviorSubject, map, Observable } from 'rxjs';

@Component({
  selector: 'cx-product-images',
  standalone: false,
  templateUrl: './custom-product-images.component.html',
})
export class CustomProductImagesComponent extends ProductImagesComponent {
  constructor(protected override currentProductService: CurrentProductService) {
    super(currentProductService);
  }

  expandImage = new BehaviorSubject(false);
  selectedIndex: number | undefined;

  override product$: Observable<Product> = this.product$;

  override openImage(item: any): void {
    this.mainMediaContainer.next(item);
    this.selectedIndex = this.mainMediaContainer.value?.zoom?.galleryIndex;
  }

  noImages$ = this.mainImage$.pipe(
    map((results) => Object.keys(results).length === 0 && results.constructor === Object)
  );

  triggerZoom(value: boolean): void {
    this.expandImage.next(value);
  }
}
